module.exports = __webpack_public_path__ + "img/Compact-SR_Overview-GB_1.3780abbd.jpg";